module.exports = __webpack_public_path__ + "log white-5fe165d1f6ec7dd19d37.svg";